gsap.registerPlugin(ScrollTrigger);

const homeText = gsap.utils.toArray('.catch__text');
const heroDoctor = gsap.utils.toArray('.heroDoctor');
const heroHygienist = gsap.utils.toArray('.heroHygienist');
const careerFlow = gsap.utils.toArray('.careerFlow');
const aboutInner = gsap.utils.toArray('.about__inner');
const start01 = 40

gsap.fromTo(homeText, {
	y: 50,
	opacity: 0,
}, {
	y: 0,
	opacity: 1,
	delay: 1.3,
	stagger: {
		amount: 0.5,
	}
});
gsap.fromTo(heroDoctor, {
	y: 50,
	opacity: 0,
}, {
	y: 0,
	opacity: 1,
	delay: 1,
	stagger: {
		amount: 0.5,
	}
});
gsap.fromTo(heroHygienist, {
	y: 50,
	opacity: 0,
}, {
	y: 0,
	opacity: 1,
	delay: 1,
	stagger: {
		amount: 0.5,
	}
});
gsap.fromTo(careerFlow, {
	y: 50,
	opacity: 0,
}, {
	y: 0,
	opacity: 1,
	scrollTrigger: {
		trigger: careerFlow,
		from: 'start',
		start: 'top center',
	},
	stagger: {
		amount: 0.2,
	}
});
gsap.fromTo(aboutInner, {
	y: 50,
	opacity: 0,
}, {
	y: 0,
	opacity: 1,
	scrollTrigger: {
		trigger: aboutInner,
		from: 'start',
		start: 'top center',
	},
	stagger: {
		amount: 0.2,
	}
});